import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'

import { TripStepTypes } from './trip-step'

export type TripStepDetails = {
  departurePlace: string
  departureTime: string
  arrivalPlace: string
  arrivalTime: string
}

export class TripStepProperties {
  static getDeparturePlaceLabel(tripStep: TripStepTypes.Basic): string {
    return tripStep.departurePlace.label ?? ''
  }

  static getArrivalPlaceLabel(tripStep: TripStepTypes.Basic): string {
    return tripStep.arrivalPlace?.label ?? ''
  }

  /**
   * Get the departure date time of a trip step
   * @param tripStep - The trip step to get the departure date time from
   * @returns HH:MM
   */
  static getDepartureDateTime(tripStep: TripStepTypes.Basic): string {
    const { departureTime } = tripStep
    return DateFormatter.HHhMM(DateFormatter.createDate(departureTime))
  }

  /**
   * Get the arrival date time of a trip step
   * @param tripStep - The trip step to get the arrival date time from
   * @returns HH:MM
   */
  static getArrivalDateTime(tripStep: TripStepTypes.Basic): string {
    const { arrivalTime } = tripStep
    return DateFormatter.HHhMM(DateFormatter.createDate(arrivalTime))
  }

  static getTripStepDetails(tripStep: TripStepTypes.Basic): TripStepDetails {
    return {
      departurePlace: this.getDeparturePlaceLabel(tripStep),
      departureTime: this.getDepartureDateTime(tripStep),
      arrivalPlace: this.getArrivalPlaceLabel(tripStep),
      arrivalTime: this.getArrivalDateTime(tripStep)
    }
  }

  static getDepartureTripStepPlaceAndParentTime(tripStep: TripStepTypes.Light): string {
    const departurePlace = this.getDeparturePlaceLabel(tripStep)
    const time = tripStep.timeBeforeDepartureForParents

    if (!departurePlace && !time) return '-'

    const formattedTime = valueRender(time, (val) => DateFormatter.getFormattedTime(val))

    return [departurePlace, formattedTime].filter(Boolean).join(' - ')
  }

  static getArrivalTripStepPlaceAndParentTime(tripStep: TripStepTypes.Light): string {
    const arrivalPlace = this.getArrivalPlaceLabel(tripStep)
    const time = tripStep.timeBeforeArrivalForParents

    if (!arrivalPlace && !time) return '-'

    const formattedTime = valueRender(time, (val) => DateFormatter.getFormattedTime(val))

    return [arrivalPlace, formattedTime].filter(Boolean).join(' - ')
  }
}
